const env = process.env.REACT_APP_ENV || 'local';

const configs = {
  local: {
    debug: true,
    interfaceURL: 'http://localhost:3000',
    apiURL: 'http://localhost:4000',
    portalURL: 'http://localhost:51033',
    //apiURL: 'https://api.poselinkcloud.com',
    //portalURL: 'https://portal.poselinkcloud.com',
    tokenExpirationMinutes: 60,
  },
  development: {
    debug: false,
    interfaceURL: 'https://manage.poselinkcloud.com',
    apiURL: 'https://api.poselinkcloud.com',
    portalURL: 'https://portal.poselinkcloud.com',
    tokenExpirationMinutes: 60,
  },
  production: {
    debug: false,
    interfaceURL: 'https://manage.positouchcloud.com',
    apiURL: 'https://api.positouchcloud.com',
    portalURL: 'https://portal.positouchcloud.com',
    tokenExpirationMinutes: 60,
  },
};

const config = configs[env];

export default config;
